import { RealEstateManualAddress } from '../../../../../@types/real-estate-api-types'
import { manualAddressType } from '../../../../../@types/types'
import { isGermanCountryCode } from '../../../../../utils/geo-utils'

export const manualAddress = (manual: RealEstateManualAddress): manualAddressType => {
  if (manual.country.id === 0) {
    return undefined
  } else {
    if (isGermanCountryCode(manual.country.id)) {
      return {
        manualAddress: {
          manualGeoCoding: {
            countries: [],
            regions: [],
            cities: [],
            quarters: [],
          },
        },
      }
    }
  }
}
